import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import BlankButton from '../../Buttons/BlankButton';

import Logo from '../../../../assets/svg/Logo';
import Dot from '../../../../assets/svg/Dot';
import Hamburger from '../../../../assets/svg/Hamburger';
import Heart from '../../../../assets/svg/Heart';
import MagnifyingGlass from '../../../../assets/svg/MagnifyingGlass';
import User from '../../../../assets/svg/User';

import HandOffLink from '../../../../utils/urls/HandOffLink';
import colors from '../../../../styling/colors';

import { openNav } from '../../../../redux/nav';
import { openAccountDrawer } from '../../../../redux/account';
import { openSearchModal } from '../../../../redux/modals';

const NavBar = styled.header`
  align-items: center;
  border-bottom: 1px solid #eee;
  display: flex;
  height: 3.5rem;
  justify-content: space-between;
  padding: 0 1rem;
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 7rem;
`;

const InlineHandOffLink = styled(HandOffLink)`
  height: 1.5rem;
`;

const IncentiveContainer = styled.div`
  position: absolute;
  right: 2px;
  top: 0px;
`;
IncentiveContainer.displayName = 'IncentiveContainer';

const UserButton = styled(BlankButton)`
  position: relative;
`;
UserButton.displayName = 'UserButton';

export class HeaderNav extends Component {
  static propTypes = {
    hasSeenSignupIncentive: PropTypes.bool,
    onHamburgerClick: PropTypes.func,
    onSearchClick: PropTypes.func,
    onUserClick: PropTypes.func,
  };

  render() {
    const {
      hasSeenSignupIncentive,
      onHamburgerClick,
      onUserClick,
      onSearchClick,
    } = this.props;

    return (
      <NavBar>
        <BlankButton onClick={onHamburgerClick}>
          <Hamburger height="1.5rem" />
        </BlankButton>
        <BlankButton onClick={onSearchClick}>
          <MagnifyingGlass height="1.5rem" />
        </BlankButton>
        <LogoWrapper>
          <HandOffLink href="/" identifier="header-home">
            <Logo />
          </HandOffLink>
        </LogoWrapper>
        <InlineHandOffLink
          href="/cards/favorites"
          identifier="header-favorites"
        >
          <Heart height="1.5rem" strokeColor={colors('lapel')} />
        </InlineHandOffLink>
        <UserButton onClick={onUserClick}>
          {hasSeenSignupIncentive ? null : (
            <IncentiveContainer>
              <Dot
                strokeColor={colors('paloma')}
                height={'0.5rem'}
                width={'0.5rem'}
              />
            </IncentiveContainer>
          )}
          <User height="1.5rem" />
        </UserButton>
      </NavBar>
    );
  }
}

const mapStateToProps = ({ account: { hasSeenSignupIncentive } }) => ({
  hasSeenSignupIncentive,
});

const mapDispatchToProps = {
  onSearchClick: openSearchModal,
  onHamburgerClick: openNav,
  onUserClick: openAccountDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderNav);
